<template>
  <div class="wrap-pic">
    <el-upload
      :http-request="uploadImg"
      :file-list="fileList"
      :on-remove="uploadRemove"
      :on-preview="handlePictureCardPreview"
      :on-success="handleSuccess"
      :class="{ disabled: uploadDisabled }"
      :limit="limit"
      :before-upload="beforeAvatarUpload"
      accept=".jpeg, .jpg, .png"
      class="picCard-upload"
      list-type="picture-card"
      action
    >
      <i class="el-icon-plus" />
    </el-upload>
    <el-dialog v-model="dialogVisible">
      <img  :src="dialogImageUrl" alt="" style="width: 100%">
    </el-dialog>
  </div>
</template>
<script>
import { uploadCommon } from '@/utils/utils'
export default {
  name: 'Upload',
  props: {
    fileListNew: {
      type: Array,
      default: null,
      dialogImageUrl: ''
    },
    limit: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: null
    },
    uploadType: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  computed: {
    uploadDisabled: function () {
      let flag = false
      console.log('type', this.type)
      if (this.type === 'detailPic') {
        if (this.fileListNew.length === 10) {
          flag = true
        }
      } else {
        if (this.fileListNew.length === 1) {
          flag = true
        }
      }

      return flag
    },
    fileList: function () {
      console.log('fileListNew', this.fileListNew)
      return this.fileListNew
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    handlePictureCardPreview (file) {
      console.log('fileee', file)
      this.dialogImageUrl = file.url
      console.log('dialogImageUrl', this.dialogImageUrl)
      this.dialogVisible = true
    },
    uploadRemove (file, fileList) {
      for (const i in this.fileList) {
        if (this.fileList[i].uid === file.uid) {
          this.fileList.splice(i, 1)
          const fileIds = []
          this.fileList.map(item => {
            fileIds.push(item.uid)
          })
          this.$emit('changeFile', this.fileList, fileIds)
          return
        }
      }
    },
    beforeAvatarUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 10
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过10MB!')
      }
      return isLt1M
    },
    uploadImg (f) {
      console.log('f', f)
      uploadCommon(f, f.file.uid).then(data => {
        console.log('dataaa', data)
        f.onSuccess({
          url: `${data}`
        })
      })
    },
    handleSuccess (data, file, fileList) {
      console.log('syccess', file.raw, data)
      this.fileList.push({
        name: file.raw.name,
        url: `https://${data.url}`,
        uid: file.raw.uid
      })
      const fileIds = []
      this.fileList.map(item => {
        fileIds.push(item.uid)
      })
      this.$emit('changeFile', this.fileList, fileIds)
    }
  }
}
</script>
<style lang="less" >
.wrap-pic {
  .el-upload--picture-card {
    width: 98px;
    height: 98px;
    line-height: 107px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 98px;
    height: 98px;
  }
  .disabled .el-upload--picture-card {
    display: none;
  }
  .el-upload-list__item .el-icon-close-tip {
    display: none!important;;
  }
  .el-icon-zoom-in {
    display: block!important;
  }
  .el-dialog__body {
    padding: 30px 20px;
    // min-height: 300px;
  }
}

</style>
